export const Resource = {
  COMPUTE_CORES: 'compute_cores',
  COMPUTE_PCI_GPU_GTX1080: 'compute_pci_gpu_gtx1080',
  COMPUTE_PCI_GPU_T4: 'compute_pci_gpu_t4',
  COMPUTE_RAM: 'compute_ram',
  EXTRATRAFFIC: 'exttraffic',
  IMAGE_GIGABYTES: 'image_gigabytes',
  LICENSE_WINDOWS_2012_STANDARD: 'license_windows_2012_standard',
  LICENSE_WINDOWS_2016_STANDARD: 'license_windows_2016_standard',
  LICENSE_WINDOWS_2019_STANDARD: 'license_windows_2019_standard',
  LOAD_BALANCERS: 'load_balancers',
  LOAD_BALANCERS_SINGLE: 'load_balancers_single_2_1024',
  LOAD_BALANCERS_STANBY_2: 'load_balancers_active_standby_2_1024',
  LOAD_BALANCERS_STANBY_4: 'load_balancers_active_standby_4_2048',
  NETWORK_FLOATINGIPS: 'network_floatingips',
  NETWORK_SUBNETS_24: 'network_subnets_24',
  NETWORK_SUBNETS_25: 'network_subnets_25',
  NETWORK_SUBNETS_26: 'network_subnets_26',
  NETWORK_SUBNETS_27: 'network_subnets_27',
  NETWORK_SUBNETS_28: 'network_subnets_28',
  NETWORK_SUBNETS_29: 'network_subnets_29',
  NETWORK_SUBNETS_29_VRRP: 'network_subnets_29_vrrp',
  NEW_EXTTRAFFIC: 'new_exttraffic',
  VOLUME_GIGABYTES_BASIC: 'volume_gigabytes_basic',
  VOLUME_GIGABYTES_FAST: 'volume_gigabytes_fast',
  VOLUME_GIGABYTES_ISO: 'volume_gigabytes_iso',
  VOLUME_GIGABYTES_LOCAL: 'volume_gigabytes_local',
  VOLUME_GIGABYTES_UNIVERSAL: 'volume_gigabytes_universal'
}

export const Group = {
  RU_1: 'ru-1',
  RU_1A: 'ru-1a',
  RU_1B: 'ru-1b',
  RU_1C: 'ru-1c',
  RU_2: 'ru-2',
  RU_2A: 'ru-2a',
  RU_2B: 'ru-2b',
  RU_2C: 'ru-2c',
  RU_3: 'ru-3',
  RU_3A: 'ru-3a',
  RU_3B: 'ru-3b',
  RU_7: 'ru-7',
  RU_7A: 'ru-7a',
  RU_8: 'ru-8',
  RU_8A: 'ru-8a',
  RU_9: 'ru-9',
  RU_9A: 'ru-9a'
}